import { useMediaQuery, useTheme } from '@mui/material'
import { logWarn } from './logger'

export const getMainElement = (): HTMLElement | null => {
  return document.getElementsByTagName('main')[0] ?? null
}

export const useScrollContainer = (): Window | HTMLElement | null => {
  const theme = useTheme()
  const upLg = useMediaQuery(theme.breakpoints.up('lg'))

  if (upLg) {
    const main = getMainElement()

    if (!main) {
      logWarn('No main element found')
      return null
    }

    return main
  }

  return window
}

type ScrollContainer = ReturnType<typeof useScrollContainer>

export const scrollElementIntoView = (scrollContainer: ScrollContainer, id: string): void => {
  if (!scrollContainer) return

  const element = document.getElementById(id)

  if (!element) return

  const offset = element.offsetTop

  /* -220 is to account for the header and have the component more centered to the screen. */
  scrollContainer.scrollTo({ top: offset - 220, behavior: 'smooth' })
}
